import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NotfoundContext } from "../../domain/interfaces/not-found.interface";

@Component({
  selector: "app-not-found-page",
  templateUrl: "./not-found-page.component.html",
  styleUrls: ["./not-found-page.component.scss"],
})
export class NotFoundPageComponent {
  public NotFoundContext = NotfoundContext;
  public context = this.router.getCurrentNavigation()?.extras?.state?.["context"];

  constructor(private router: Router) {}

  /**
   * Navigates back to the landing page.
   */
  public returnHome(): void {
    this.router.navigate(["landing"]);
  }
}
